import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Controller, useFormContext } from 'react-hook-form';
import { Image } from 'react-bootstrap';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import {
  PERIOD_TYPE_DISPLAY,
  PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE,
  PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE_DISPLAY,
  TRANSACTION_TYPE_DISPLAY
} from 'config/CustomEnums';
import InputWithMutipleDropDown from './InputWithMutipleDropDown';
import LookupWithMutipleNumber from './LookupWithMutipleNumber';
import CustomRadios from 'components/base/CustomRadios';
import { DropDownWithDefaultSelect } from 'components/base/ActionsDropdown';
import { hasReactHookFormError } from 'components/base/ErrorFieldMessage';
import BranchLine from 'assets/images/branchLinex3.png';
import { StoreMultipleSelector } from 'components/earning/TargetTypeCustomerSelector';

const PurchaseInStoreSection = ({
  title,
  groupName,
  fieldBaseName,
  timeSelectorDescription,
}) => {
  const {
    watch,
    setValue,
    control,
    formState: { errors },
  } = useFormContext();
  const storeTypeFieldName = `${fieldBaseName}.storeType`;
  const storeType = watch(storeTypeFieldName) || PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE['All online stores'];

  const storesFieldName = `${fieldBaseName}.stores`;

  const typeFieldName = `${fieldBaseName}.type`;
  const type = watch(typeFieldName);

  const dropDownOptions = (values, setAction) => {
    return values.map((value) => ({
      name: value,
      action: () => {
        setAction(value);
      },
    }));
  };

  return (
    <div className="d-flex flex-column">
      <CustomTitleLabel title={title} />
      <div className="display-flex-area">
        <Controller
          name={storeTypeFieldName}
          control={control}
          render={({ field }) => (
            <CustomRadios
              labelClass="font-weight"
              onChange={(value) => {
                setValue(field.name, value, { shouldDirty: true });
              }}
              default={storeType}
              options={[
                {
                  label: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE_DISPLAY.ALL_ONLINE_STORE,
                  value: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE['All online stores'],
                },
                {
                  label: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE_DISPLAY.ALL_OFFLINE_STORE,
                  value: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE['All offline stores'],
                },
                {
                  label: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE_DISPLAY.SPECIFIC_STORE,
                  value: PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE['Specific store(s)'],
                },
              ]}
            />
          )}
        />
      </div>

      {
        storeType === PURCHASE_IN_STORE_TRANSACTION_STORE_TYPE['Specific store(s)']
          ? (
            <StoreMultipleSelector
              title='Specific store(s)'
              valueFieldName={storesFieldName}
            />
          )
          : null
      }
      <InputWithMutipleDropDown
        fieldBaseName={fieldBaseName}
        title={"Time period"}
        hasPeriodDropdown
        timeSelectorDescription={timeSelectorDescription}
      />

      <CustomTitleLabel title="Number of transaction (optional)"/>
      <div className="d-flex">
        <Controller
          name={typeFieldName}
          control={control}
          rules={{ required: false }}
          render={({ field }) => (
            <DropDownWithDefaultSelect
              actions={dropDownOptions(
                [
                  TRANSACTION_TYPE_DISPLAY.NUMBER,
                  TRANSACTION_TYPE_DISPLAY.PERCENTAGE,
                ],
                (value) => {
                  setValue(field.name, value, {
                    shouldDirty: true,
                    shouldValidate: true,
                  });
                },
              )}
              defaultValue={type}
              className={
                hasReactHookFormError(errors, field.name) ? 'error-field' : ''
              }
            />
          )}
        />

        <label className="content-campaign-related-to margin-right-10-percent">
          of transaction
        </label>
      </div>

      <div className="d-flex">
        <Image src={BranchLine} className="content-campaign-branchLine" />
        <div className="segment-with-line-margin">
          <LookupWithMutipleNumber
            fieldBaseName={fieldBaseName}
            groupName={groupName}
            title={null}
            extraSuffix={type === TRANSACTION_TYPE_DISPLAY.PERCENTAGE ? '%' : null}
            notRequired
          />
        </div>
      </div>
    </div>
  );
}

export default PurchaseInStoreSection;
